"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailIcon24 = void 0;
var react_1 = __importStar(require("react"));
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var build_svg_icon_1 = require("../../build-svg-icon");
exports.EmailIcon24 = (0, build_svg_icon_1.buildSvgIcon)(function () {
    var _a = __read((0, react_1.useState)((0, uniqueId_1.default)('email-icon24')), 1), uniqueId = _a[0];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 7.93638V18H20V7.93638L13.2494 14.2811C12.519 14.8655 11.481 14.8655 10.7506 14.2811L4 7.93638ZM5.91504 7L12.0003 12.7194L18.0855 7H5.91504ZM4 5H20C21.1046 5 22 5.89543 22 7V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V7C2 5.89543 2.89543 5 4 5Z", fill: "currentColor" }),
        react_1.default.createElement("mask", { id: uniqueId, style: { maskType: 'luminance' }, maskUnits: "userSpaceOnUse", x: "2", y: "5", width: "20", height: "15" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 7.93638V18H20V7.93638L13.2494 14.2811C12.519 14.8655 11.481 14.8655 10.7506 14.2811L4 7.93638ZM5.91504 7L12.0003 12.7194L18.0855 7H5.91504ZM4 5H20C21.1046 5 22 5.89543 22 7V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V7C2 5.89543 2.89543 5 4 5Z", fill: "currentColor" })),
        react_1.default.createElement("g", { mask: "url(#".concat(uniqueId, ")") })));
}, 'EmailIcon24', { viewBox: '0 0 24 24' });
exports.default = exports.EmailIcon24;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRW1haWxJY29uMjQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9kZXNpZ24tc3lzdGVtLWljb25zL3VpLWljb25zLzI0L0VtYWlsSWNvbjI0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2Q0FBd0M7QUFDeEMsNkRBQXdDO0FBQ3hDLHVEQUFvRDtBQUV2QyxRQUFBLFdBQVcsR0FBRyxJQUFBLDZCQUFZLEVBQ3JDO0lBQ1EsSUFBQSxLQUFBLE9BQWEsSUFBQSxnQkFBUSxFQUFDLElBQUEsa0JBQVMsRUFBQyxjQUFjLENBQUMsQ0FBQyxJQUFBLEVBQS9DLFFBQVEsUUFBdUMsQ0FBQztJQUN2RCxPQUFPLENBQ0w7UUFDRSx3Q0FDRSxRQUFRLEVBQUMsU0FBUyxFQUNsQixRQUFRLEVBQUMsU0FBUyxFQUNsQixDQUFDLEVBQUMsdVFBQXVRLEVBQ3pRLElBQUksRUFBQyxjQUFjLEdBQ25CO1FBQ0Ysd0NBQ0UsRUFBRSxFQUFFLFFBQVEsRUFDWixLQUFLLEVBQUUsRUFBRSxRQUFRLEVBQUUsV0FBVyxFQUFFLEVBQ2hDLFNBQVMsRUFBQyxnQkFBZ0IsRUFDMUIsQ0FBQyxFQUFDLEdBQUcsRUFDTCxDQUFDLEVBQUMsR0FBRyxFQUNMLEtBQUssRUFBQyxJQUFJLEVBQ1YsTUFBTSxFQUFDLElBQUk7WUFFWCx3Q0FDRSxRQUFRLEVBQUMsU0FBUyxFQUNsQixRQUFRLEVBQUMsU0FBUyxFQUNsQixDQUFDLEVBQUMsdVFBQXVRLEVBQ3pRLElBQUksRUFBQyxjQUFjLEdBQ25CLENBQ0c7UUFDUCxxQ0FBRyxJQUFJLEVBQUUsZUFBUSxRQUFRLE1BQUcsR0FBSSxDQUMvQixDQUNKLENBQUM7QUFDSixDQUFDLEVBQ0QsYUFBYSxFQUNiLEVBQUUsT0FBTyxFQUFFLFdBQVcsRUFBRSxDQUN6QixDQUFDO0FBRUYsa0JBQWUsbUJBQVcsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/design-system-icons/ui-icons/24/EmailIcon24.js
// module id = 6555
// module chunks = 6